import { ArticleWithBg, BackgroundType, ContentType, FeatureWithBg } from "./types";

export const ContentTypes = [ContentType.Article, ContentType.Featured];

export const ArticleCards: ArticleWithBg[] = [];

export const HolidayCampaignCard: ArticleWithBg = {
  type: "article",
  title: (
    <span>
      Get ready for <br />
      the Holidays
    </span>
  ),
  description: "Update your holiday messages today",
  linkUrl: "https://phmg.com/global-holiday-campaign?utm_source=Portal&utm_medium=SignIn&utm_campaign=HolidayCampaign",
  callToAction: "Update Now",
  theme: "dark",
  backgroundType: BackgroundType.Image,
  src: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/HolidayCampaignBg.png",
  overlayStyle: "text-white ",
};

export const FeatureCards: FeatureWithBg[] = [
  // {
  //   type: "article",
  //   title: <>Let's talk 2026.</>,
  //   description:
  //     "Speak to your account manager to see how a quick conversation now can set you up for a smoother, better-sounding year ahead.",
  //   backgroundType: BackgroundType.Image,
  //   src: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/ClientPortal-2026CampaignLoginImage.png",
  //   overlayStyle: "text-black",
  //   cardBgColor: "bg-white",
  // },
  {
    type: "feature",
    title: (
      <>
        Smarter calls.
        <br />
        <b>Stronger brand.</b>
      </>
    ),
    description:
      "Enhanced by PHMG’s creative and technical mastery, this cloud-based phone system uses GoTo’s trusted platform to deliver seamless, on-brand caller experiences every time.",
    callToAction: "Explore GoTo Connect",
    imageUrl: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/GoTo+-+Black.svg",
    linkUrl: "https://phmg.com/cloud-telephony-goto/?utm_source=client-portal",
    backgroundType: BackgroundType.Image,
    src: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/GoTo-PortalBG.avif",
    overlayStyle: "text-black",
  },
  {
    type: "feature",
    title: (
      <>
        Talk is cheap.
        <br />
        <b>Silence is expensive.</b>
      </>
    ),
    description: "Expert call handling and system fine-tuning to capture every opportunity.",
    callToAction: "Explore Complete Caller Experience",
    imageUrl: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/CCE+-+White.svg",
    linkUrl: "https://phmg.com/services/complete-caller-experience/?utm_source=client-portal",
    backgroundType: BackgroundType.Image,
    src: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/CCE-PortalBG.avif",
    overlayStyle: "text-white",
  },
  // {
  //   title: "Your brand,<br>your voice,<br> <b>your way.</b>",
  //   description:
  //     "A full-service audio branding solution built to elevate your brand across every platform. It's fast, flexible and unmistakably you.",
  //   callToAction: "Explore Brand Sound Pro",
  //   imageUrl: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/Brand+Sound+Pro+-+White.svg",
  //   linkUrl: "https://phmg.com/about/brand-sound-pro-client-portal/?utm_medium=client-portal",
  //   type: BackgroundType.Image,
  //   src: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/BrandSoundPro-PortalBG-min.avif",
  // },
  // {
  //   title: "Your brand,<br> conducted in <br><b>total harmony.</b>",
  //   description:
  //     "A truly bespoke creative experience developed with world-renowned composers and copywriters to bring your brand’s story to life through unforgettable sound.",
  //   callToAction: "Explore Brand Symphony",
  //   imageUrl: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/Brand+Symphony+-+White.svg",
  //   linkUrl: "https://phmg.com/about/brand-symphony-client-portal/?utm_source=client-portal",
  //   type: BackgroundType.Image,
  //   src: "https://phmg-styles.s3.eu-west-2.amazonaws.com/images/BrandSymphony-PortalBG-min.avif",
  // },
];
